// extracted by mini-css-extract-plugin
export default {"subTitle":"Retention_subTitle__I55yE","minHeight":"Retention_minHeight__96oFQ"};